import React from 'react';
import { Avatar, AvatarImage, AvatarFallback } from '@/components/ui/avatar';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const COLORS = ['bg-blue-600', 'bg-emerald-600', 'bg-amber-600', 'bg-rose-600', 'bg-violet-600', 'bg-cyan-700', 'bg-orange-600', 'bg-teal-600'];
const SIZES = { xs: 'h-6 w-6 text-[10px]', sm: 'h-8 w-8 text-xs', md: 'h-10 w-10 text-sm', lg: 'h-20 w-20 text-xl' };

export const avatarSrc = (url) => (url ? (url.startsWith('http') ? url : `${BACKEND_URL}${url}`) : undefined);

export const UserAvatar = ({ person, size = 'md', className = '', testId }) => {
  const first = person?.first_name || '';
  const last = person?.last_name || '';
  const initials = `${first[0] || ''}${last[0] || ''}`.toUpperCase() || '?';
  const color = COLORS[(first.length * 7 + last.length * 3) % COLORS.length];
  return (
    <Avatar className={`${SIZES[size]} ${className}`} data-testid={testId}>
      {person?.avatar_url && <AvatarImage src={avatarSrc(person.avatar_url)} alt={`${first} ${last}`} className="object-cover" />}
      <AvatarFallback className={`${color} text-white font-semibold`}>{initials}</AvatarFallback>
    </Avatar>
  );
};

export default UserAvatar;
